// Updated: 2026-01-12 18:01
class AgendaLoadMore {
  constructor() {
    console.log('AgendaLoadMore inicializado - v2.0');
    this.agendaData = this.loadData();
    this.itemsPerLoad = 18;
    this.currentIndex = 0;
    this.loadMoreBtn = document.getElementById('load-more-btn');
    this.gridContainer = document.getElementById('agenda-grid-container');
    this.filteredData = [...this.agendaData]; // Cópia para manter dados filtrados
    this.activeFilters = { categories: [], sortOrder: '', year: '' };

    console.log('Dados carregados:', this.agendaData.length, 'itens');
    console.log('loadMoreBtn:', this.loadMoreBtn);
    console.log('gridContainer:', this.gridContainer);

    this.init();
  }

  loadData() {
    console.log('=== AGENDA LOAD DATA v2026-01-15-SORT-FIX ===');
    const dataScript = document.getElementById('agenda-data');
    console.log('Script de dados encontrado:', !!dataScript);
    
    if (dataScript) {
      try {
        const data = JSON.parse(dataScript.textContent);
        console.log('JSON parsed com sucesso:', data);
        console.log('Número de entries:', data.entries ? data.entries.length : 0);
        
        const entries = data.entries || [];
        
        // Ordenar por data_evento do mais recente para o mais antigo
        entries.sort((a, b) => {
          const dateA = a.data_evento || '1900-01-01';
          const dateB = b.data_evento || '1900-01-01';
          // Decrescente: mais recente primeiro
          return dateB.localeCompare(dateA);
        });
        
        console.log('Primeiros 5 após ordenação:');
        entries.slice(0, 5).forEach(entry => {
          console.log('Entry completo:', JSON.stringify(entry, null, 2));
          console.log('- data_evento:', entry.data_evento, 'tipo:', typeof entry.data_evento);
          console.log('- data:', entry.data, 'tipo:', typeof entry.data);
          console.log('- titulo:', entry.titulo);
        });
        
        return entries;
      } catch (e) {
        console.error('Erro ao parsear dados de agenda:', e);
        console.error('Conteúdo do script:', dataScript.textContent.substring(0, 200));
        return [];
      }
    }
    return [];
  }

  init() {
    if (!this.loadMoreBtn || !this.gridContainer) {
      console.error('loadMoreBtn ou gridContainer não encontrados');
      return;
    }

    if (this.agendaData.length === 0) {
      console.warn('Nenhum dado de agenda disponível');
      return;
    }

    console.log('Iniciando carregamento de agenda');

    // Verificar se há filtros na URL
    const hasFiltersInURL = this.checkFiltersInURL();
    console.log('*** CACHE TEST v3.0 - hasFiltersInURL:', hasFiltersInURL);
    console.log('*** URL atual:', window.location.search);
    
    // Só carregar os primeiros itens se não houver filtros na URL
    // Se houver filtros, esperar pelo evento 'agenda-filter-change'
    if (!hasFiltersInURL) {
      console.log('*** Sem filtros na URL, carregando itens iniciais');
      this.loadMoreItems();
    } else {
      console.log('*** Filtros detectados na URL, aguardando evento de filtro');
    }

    this.loadMoreBtn.addEventListener('click', () => {
      console.log('Botão Load More clicado');
      this.loadMoreItems();
    });

    // Escutar mudanças de filtro
    document.addEventListener('agenda-filter-change', (e) => {
      console.log('Filtro mudou:', e.detail);
      this.applyFilters(e.detail);
    });
  }

  checkFiltersInURL() {
    const params = new URLSearchParams(window.location.search);
    return params.has('categoria') || params.has('ano') || params.has('sort');
  }

  loadMoreItems() {
    console.log('loadMoreItems chamado. currentIndex:', this.currentIndex, 'total:', this.filteredData.length);
    
    if (this.filteredData.length === 0) {
      console.log('Nenhum item filtrado para mostrar');
      this.loadMoreBtn.parentElement.style.display = 'none';
      return;
    }
    
    const endIndex = Math.min(this.currentIndex + this.itemsPerLoad, this.filteredData.length);
    console.log('Carregando itens de', this.currentIndex, 'até', endIndex);
    
    let itemsAdded = 0;
    for (let i = this.currentIndex; i < endIndex; i++) {
      const entry = this.filteredData[i];
      console.log('Adicionando entry:', entry.titulo);
      this.addEntryToGrid(entry);
      itemsAdded++;
    }
    
    console.log('Total de itens adicionados:', itemsAdded);

    this.currentIndex = endIndex;

    // Esconder botão se chegou ao fim
    if (this.currentIndex >= this.filteredData.length) {
      this.loadMoreBtn.parentElement.style.display = 'none';
      console.log('Todas as entradas carregadas. Total no grid:', this.currentIndex);
    } else {
      this.loadMoreBtn.parentElement.style.display = 'block';
      console.log('Ainda há mais itens. Mostrando botão.');
    }

    // Disparar evento para atualizar filtros se houver
    document.dispatchEvent(new CustomEvent('agenda-entries-loaded'));
    
    // Ordenar por data dentro de cada seção de ano
    this.sortByDateWithinSections();
  }

  sortByDateWithinSections() {
    const yearSections = this.gridContainer.querySelectorAll('.agenda-year-section');
    
    yearSections.forEach((section) => {
      const grid = section.querySelector('.agenda-year-grid');
      const entries = Array.from(grid.querySelectorAll('.agenda-entry'));
      
      entries.sort((a, b) => {
        const dateA = a.getAttribute('data-data');
        const dateB = b.getAttribute('data-data');
        return this.compareDates(dateA, dateB);
      });

      // Reorganizar os elementos no DOM
      entries.forEach((entry) => {
        grid.appendChild(entry);
      });
    });
  }

  applyFilters(filters) {
    console.log('*** applyFilters INICIO', filters);
    console.log('Dados agendaData disponíveis:', this.agendaData.length, 'itens');
    
    const { categories, year, sortOrder } = filters;
    const hasFilterChanges = (
      (filters.categories && filters.categories.length > 0) ||
      filters.year
    );
    const hasSortOrderChange = sortOrder !== this.activeFilters.sortOrder;

    console.log('*** hasFilterChanges:', hasFilterChanges, 'hasSortOrderChange:', hasSortOrderChange, 'currentIndex:', this.currentIndex);

    // Verificar se há filtros ativos ou se é a primeira vez
    const hadActiveFilters = this.activeFilters.categories.length > 0 || this.activeFilters.year;
    const hasActiveFilters = (categories && categories.length > 0) || year;

    // Se apenas a ordenação mudou e há itens no grid, não resetar - apenas reorganizar
    if (hasSortOrderChange && !hasFilterChanges && this.currentIndex > 0) {
      console.log('*** RETURN: Apenas ordenação mudou, reorganizando grid atual');
      this.sortGridEntries(sortOrder);
      this.activeFilters.sortOrder = sortOrder;
      return;
    }

    console.log('*** Continuando após check de ordenação');

    // Se categoria ou ano mudaram, resetar tudo
    this.activeFilters = filters;
    
    // Limpar grid
    this.gridContainer.innerHTML = '';
    this.currentIndex = 0;
    
    console.log('*** Grid limpo, iniciando filtragem');
    
    const getEntryYear = (entry) => {
      if (!entry) return '';
      if (entry.ano !== undefined && entry.ano !== null && `${entry.ano}`.trim() !== '') {
        return `${entry.ano}`.trim();
      }
      const dateStr = (entry.data || entry.data_evento || '').toString();
      if (!dateStr) return '';
      // aceita "YYYY-MM-DD" e variações (incluindo timestamps)
      const match = dateStr.match(/^(\d{4})/);
      return match ? match[1] : '';
    };

    const selectedYear = year ? `${year}`.trim() : '';

    console.log('*** Antes do filter, agendaData.length:', this.agendaData.length);

    try {
      // Aplicar filtros aos dados originais
      this.filteredData = this.agendaData.filter(entry => {
      // Filtrar por ano
      if (selectedYear) {
        const entryYear = getEntryYear(entry);
        if (entryYear !== selectedYear) {
          return false;
        }
      }
      
      
      // Filtrar por categorias
      if (categories && categories.length > 0) {
        const entryHasCategory = categories.some(cat => {
          const cleanCat = cat.toLowerCase().replace(/\s+/g, '-');
          const entryCategoriesArray = entry.categorias && Array.isArray(entry.categorias) ? entry.categorias : [];
          const entryCategoriesClean = entryCategoriesArray.map(c => c.toLowerCase().replace(/\s+/g, '-'));
          const hasCategory = entryCategoriesClean.includes(cleanCat);
          console.log(`Verificando: "${cat}" (${cleanCat}) em [${entryCategoriesClean.join(', ')}] = ${hasCategory}`);
          return hasCategory;
        });
        
        if (!entryHasCategory) {
          return false;
        }
      }
      
      return true;
    });
    
    console.log('*** Após filter, filteredData.length:', this.filteredData.length);
    
    // Aplicar ordenação
    if (sortOrder) {
      this.filteredData.sort((a, b) => {
        if (sortOrder === 'asc') {
          return a.titulo.localeCompare(b.titulo);
        } else {
          return b.titulo.localeCompare(a.titulo);
        }
      });
    } else {
      // Ordenar por data (mais recente primeiro) se não houver sort order selecionado
      this.filteredData.sort((a, b) => {
        return this.compareDates(b.data, a.data);
      });
    }
    
    console.log('*** Dados filtrados e ordenados:', this.filteredData.length, 'itens');
    
    // Recarregar a grid com os dados filtrados
    console.log('*** Chamando loadMoreItems()');
    this.loadMoreItems();
    console.log('*** loadMoreItems() terminou');
    
    } catch (error) {
      console.error('*** ERRO em applyFilters:', error);
    }
  }

  sortGridEntries(sortOrder) {
    console.log('sortGridEntries chamado com:', sortOrder);
    const yearSections = this.gridContainer.querySelectorAll('.agenda-year-section');
    
    yearSections.forEach((section) => {
      const grid = section.querySelector('.agenda-year-grid');
      const entries = Array.from(grid.querySelectorAll('.agenda-entry'));
      
      entries.sort((a, b) => {
        const titleA = a.getAttribute('data-titulo');
        const titleB = b.getAttribute('data-titulo');

        if (sortOrder === 'asc') {
          return titleA.localeCompare(titleB);
        } else {
          return titleB.localeCompare(titleA);
        }
      });

      // Reorganizar os elementos no DOM
      entries.forEach((entry) => {
        grid.appendChild(entry);
      });
    });
  }

  compareDates(dateA, dateB) {
    // Formato: YYYY-MM-DD
    if (!dateA) return 1;  // Sem data vai para o fim
    if (!dateB) return -1; // Sem data vai para o fim
    
    // Converter para string se necessário
    const dateStrA = String(dateA);
    const dateStrB = String(dateB);
    
    const [yearA, monthA, dayA] = dateStrA.split('-').map(Number);
    const [yearB, monthB, dayB] = dateStrB.split('-').map(Number);
    
    const dateObjA = new Date(yearA, monthA - 1, dayA);
    const dateObjB = new Date(yearB, monthB - 1, dayB);
    
    return dateObjB - dateObjA; // Mais recente primeiro
  }

  addEntryToGrid(entry) {
    const { ano, titulo, subtitulo, data, data_evento, data_formatada, imagem, categorias, artistas, col_class, data_titulo, data_categoria, url_page } = entry;

    // Criar ou obter a seção do ano
    let yearSection = this.gridContainer.querySelector(`[data-year="${ano}"]`);
    
    if (!yearSection) {
      console.log('Criando nova seção para ano:', ano);
      yearSection = document.createElement('div');
      yearSection.className = 'agenda-year-section';
      yearSection.setAttribute('data-year', ano);
      
      const title = document.createElement('h2');
      title.className = 'h4 agenda-year-title';
      title.textContent = ano;
      
      const gridRow = document.createElement('div');
      gridRow.className = 'row agenda-year-grid';
      gridRow.setAttribute('data-year-grid', ano);
      
      yearSection.appendChild(title);
      yearSection.appendChild(gridRow);
      
      // Inserir seção na ordem correta (mais recente primeiro)
      const existingSections = Array.from(this.gridContainer.querySelectorAll('.agenda-year-section'));
      let inserted = false;
      
      for (let section of existingSections) {
        const sectionYear = parseInt(section.getAttribute('data-year'));
        if (parseInt(ano) > sectionYear) {
          this.gridContainer.insertBefore(yearSection, section);
          inserted = true;
          break;
        }
      }
      
      if (!inserted) {
        this.gridContainer.appendChild(yearSection);
      }
    }

    // Criar elemento do entry
    const entryDiv = document.createElement('div');
    entryDiv.className = `${col_class} col-12 agenda-entry`;
    entryDiv.setAttribute('data-year', ano);
    entryDiv.setAttribute('data-categoria', data_categoria);
    entryDiv.setAttribute('data-titulo', data_titulo);
    entryDiv.setAttribute('data-data', data || '9999-12-31'); // Datas vazias vão pro fim

    let categoriasHTML = '';
    if (categorias && Array.isArray(categorias) && categorias.length > 0) {
      categoriasHTML = `
        <div class="tags tags-image">
          ${categorias.map(cat => `<span>${cat}</span>`).join('')}
        </div>
      `;
    }

    let artistasHTML = '';
    if (artistas && Array.isArray(artistas) && artistas.length < 2) {
      artistasHTML = `
        <div class="artista-event text-uppercase paragraph-lg">
          ${artistas.map((artist, idx) => {
            const artistName = typeof artist === 'object' ? artist.titulo : artist;
            const comma = idx < artistas.length - 1 ? ', ' : '';
            return `<span>${artistName}</span>${comma}`;
          }).join('')}
        </div>
      `;
    }

    let dataHTML = '';
    if (data_formatada) {
      dataHTML = `<div class="event-date mt-3"><p>${data_formatada}</p></div>`;
    }

    entryDiv.innerHTML = `
      <div class="agenda-event position-relative">
        <div class="image position-relative">
          ${imagem ? `<a href="${url_page}" title="${titulo}"><div class="ratio ratio-4x3"><img src="${imagem}" alt="${titulo}" class="w-100 imageShare-page img-fluid" /></div></a>` : ''}
          ${categoriasHTML}
        </div>
        <div class="infos mt-5">
          ${subtitulo ? `<div class="category paragraph-sm mb-3">${subtitulo}</div>` : ''}
          <h3 class="event-title my-3">
            <a href="${url_page}" class="no-decoration-black stretched-link" title="${titulo}">
              ${titulo}
            </a>
          </h3>
        </div>
        ${artistasHTML}
        ${dataHTML}
      </div>
    `;

    const yearGrid = yearSection.querySelector('[data-year-grid]');
    yearGrid.appendChild(entryDiv);
  }
}

// Inicializar quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    console.log('DOMContentLoaded disparado');
    new AgendaLoadMore();
  });
} else {
  console.log('DOM já pronto, inicializando AgendaLoadMore');
  new AgendaLoadMore();
}
